<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			title: string;
			text: ISbRichtext;
			asset: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div class="flex h-full flex-col justify-between" use:editable={content}>
	<div class="text-brown-2">
		<p class="text-[24px]/[110%] font-semibold">{content.title || ''}</p>
		<div class="mt-3 text-[16px]/[150%]">
			<SbRichtext text={content.text} />
		</div>
	</div>
	{#if content.asset[0]}
		<div class="mt-5 aspect-square min-h-40 flex-shrink overflow-hidden rounded-2xl lg:aspect-3/2">
			<Blok content={content.asset[0]} />
		</div>
	{/if}
</div>
